module.exports = __webpack_public_path__ + "img/contact_banner_title.aeb2f3a9.png";